import React, { Component } from "react";
import { Button } from "packages/components";

interface IProps{
    label: React.ReactNode;
    onClick?: (isButtonDisabled?: Boolean) => void;
    timeToEnabled?: number;
    maxNumResends: number;
    countResends: number;
    style?: React.CSSProperties;
    classname?: string;
    startDisabled?: boolean;
    onTimeOut?: (isButtonDisabled?: Boolean) => {}
}

interface IState {
    disabled: boolean;
}

class ResendCodeButton2FA extends Component<IProps, IState>{
    private timer: ReturnType<typeof setTimeout> | undefined;

    constructor(props: IProps){
        super(props);
        this.state = {
            disabled: this.props.startDisabled ?? true
        };

        this.timer = undefined
        this.startTimer = this.startTimer.bind(this);
        this.handleClick = this.handleClick.bind(this);
        
    }

    componentWillReceiveProps(nextProps: IProps): void {
        if (this.timer) clearTimeout(this.timer);
        if ((nextProps.countResends < nextProps.maxNumResends) && this.state.disabled) this.startTimer();  
    }

    componentDidMount(): void {
       if ((this.props.countResends < this.props.maxNumResends) && this.state.disabled) this.startTimer();
       if (this.props.countResends >= this.props.maxNumResends)  this.setState({disabled: true});
    }

    componentWillUnmount(): void {
        if (this.timer) clearTimeout(this.timer);
    }

    startTimer = () => {
        this.timer = setTimeout(() => {
            this.setState({disabled: false});
            this.props.onTimeOut && this.props.onTimeOut(this.state.disabled)
        }, this.props.timeToEnabled || 0);
    }

    handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>){
        if (this.state.disabled) return; 
        event.preventDefault();
        event.stopPropagation();
        this.setState({disabled: true});
        this.props.onClick && this.props.onClick(!this.state.disabled);
    }


    render(){
        const { label, classname, style } = this.props;
        return(
            <Button
                id="resendMessage"
                type="button"
                variant="primary"
                disabled = {this.state.disabled}
                onClick={this.handleClick}
                className={`primaryButton focusable ${classname}`}
                style={style}
            >
                {label}
            </Button>
        )
    }
}

export default ResendCodeButton2FA;


// WEBPACK FOOTER //
// ./src/components/ResendCodeButton2FA/ResendCodeButton2FA.tsx